import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '@core/services/data.service';

export interface IUserCourseCertificate {
  id: number;
  userId: number;
  courseId: number;
  schoolYearId: number;
  awardedOn: string;
  courseName: string;
  schoolYearName: string;
}

@Injectable({ providedIn: 'root' })
export class CertificateService {
  private dataService = inject(DataService);

  getMyCertificates(): Observable<IUserCourseCertificate[]> {
    return this.dataService.get('Module/certificates');
  }

  hasCertificate(courseId: number): Observable<boolean> {
    return this.dataService.get(`Module/certificate/course/${courseId}`, undefined, false);
  }

  hasEarnedCertificateThisYear(): Observable<boolean> {
    return this.dataService.get('Module/certificate/earned-this-year', undefined, false);
  }

  tryAwardCertificate(courseId: number): Observable<IUserCourseCertificate | null> {
    return this.dataService.post(`Module/certificate/award/${courseId}`, {});
  }

  downloadCertificate(courseId: number): Observable<Blob> {
    return this.dataService.postWithOptions(
      `Module/certificate/download/${courseId}`,
      {},
      { responseType: 'blob' }
    );
  }
}
